import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslationPipe } from "./translation.pipe";

@NgModule({
  declarations: [TranslationPipe],
  exports: [TranslationPipe],
  imports: [CommonModule],
})
export class TranslationModule { }
